'use strict'

export const DOCUMENT = {}
